import { 
	AuthRepository,
} from "../../api";

export class LoginController {
	constructor(context) {
		this.changeAction = this.changeAction.bind(context);
		this.submitAction = this.submitAction.bind(context);
		this.forgotPassword = this.forgotPassword.bind(context);

		this.authRepo = new AuthRepository();
	}

	showIeMessage() {
		const targetClick = document.querySelectorAll("a[href='#ie']");
		targetClick[0].click();
	}

	changeAction(e) {
		const state = this.getState();
		state[e.target.id] = e.target.value;

		this.callback(state);
	}

	async submitAction(e) {
		e.preventDefault();
		if(!this.state.EMAIL.toLowerCase() || !this.state.PASSWORD)
			return this.callback({error: { email: "Preencha todos os campos" }});
		const authPromise = await this.controller.authRepo.authorize(this.state.EMAIL.toLowerCase(), this.state.PASSWORD);

		
		if(!authPromise.error){
			window.sessionStorage.setItem("session_token", authPromise.data.token);
			return this.props.router.push("/dashboard");
		}
		if(authPromise.error.code == "604"){
			this.callback({error: { password: "Senha incorreta" }});
		} else if(authPromise.error.code == "603") {
			this.callback({error: { email: "Email incorreto" }});
		} else {
			this.callback({error: { email: "Erro em nossos servidores" }});
		}
	}

	async forgotPassword() {
		const { EMAIL } = this.state;
		if(!EMAIL)
			return this.callback({error: { email: "Preencha seu email!" }});

		
		const authPromise = await this.controller.authRepo.forgotPassword({ email: EMAIL.toLowerCase() });
		if(authPromise.error) {
			let error = "";
			switch(authPromise.error.code) {
				case 603: error = "Email não encontrado!"; break;
				default: error = "Ocorreu um erro em nossos servidores.";
			}

			this.callback({ error: { email: error }});
		}

	}

	async resetPassword() {
		const { user_id, token } = this.props.location.query;
		if (user_id && token) {
			const result = await this.controller.authRepo.validateResetPasswordToken(token);
			if(!result.error)
				this.props.showResetPasswordModalAction({user_id, token});
			this.props.router.push("/");
		}
	}

}



// WEBPACK FOOTER //
// src/controllers/lib/LoginController.js